import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Grid, useMediaQuery } from '@mui/material';
import {
  PageContainer,
  FilterPod,
  Empty,
  PaginationComponenets,
  ReceiveFile,
  LoadingPage,
  Icons,
} from 'components';
import { enifyDateTime } from 'utility';
import { toFilterVOS, filterVOStoQueryStr } from 'components/FilterPod';
import { generateData } from './components/Columns';
import ImprestServices from '../services/ImprestServices';
import InitFilters from './constants/InitFiltering';
import { useStyles } from './style';
import ImprestReportSummary from './components/ImprestReportSummary';
import useCustomHook from '../hooks';
import FilterButton from 'components/FilterPod/FilterButton';
import { getDynamicObjectAction, constBreadCrumbsTitle, getDynamicReportPages } from 'utility';
import { ImprestItem, ImprestItemReport } from './components';
import { useCurrencyUnit } from 'hooks';
let filterTemp = [];
export default function ImprestList() {
  const reportElement = getDynamicReportPages(['imprestList']);
  const actionsList = getDynamicObjectAction([
    'imprestListRedirectToAddImprestBtn',
    'imprestListTable',
    'imprestListTransferAction',
    'imprestListDelegationAction',
    'imprestListZeroOutAction',
    'imprestListFinancialLimitAction',
    'imprestListOtherTransferAction',
    'imprestListOtherInvoiceCreateAction',
    'imprestListOtherBalanceAction',
    'imprestListUpdateAction',
    'imprestListUpdateActivationAction',
    'imprestListDetailAction',
    'imprestListBillAction',
    'imprestListChargeBtn',
    'imprestListReportBtn',
    'imprestCardService',
  ]);
  const currencyText = useCurrencyUnit(false);
  const matches = useMediaQuery('(max-width:940px)');

  const [filters, setFilters] = useState(InitFilters());
  const {
    filterParams,
    setFilterParams,
    accountDetails,
    setAccountDetails,
    loading,
    setLoading,
    size,
    page,
    currentPage,
    setCurrentPage,
    totalCount,
    setTotoalCount,
    paramsData,
    setParamsData,
  } = useCustomHook();

  useEffect(() => {
    filterTemp = [];
    getBranchesList();
    paginationOnChange({
      page: currentPage === 0 ? 1 : currentPage,
      pageSize: 12,
      pageNumber: currentPage === 0 ? 0 : currentPage - 1,
      changeData: true,
    });
  }, [currentPage]);

  //--HOOKS--//
  const classes = useStyles();

  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const handleCloseFilterDialog = () => setOpenFilterDialog(false);

  const navigate = useNavigate();

  //--API REQUESTS--//
  const getBranchesList = async (query) => {
    try {
      setLoading(true);
      let filter = toFilterVOS([...filterTemp]);
      let queries = filterVOStoQueryStr(filter);

      const params = {
        ...queries,
        offset: currentPage === 0 ? 0 : (currentPage - 1) * 12,
        size: query ? query?.pageSize : size,
        startDate: filters.find((a) => a.keyName === 'dateRange')?.value?.start
          ? enifyDateTime(
              filters.find((a) => a.keyName === 'dateRange').value?.start?.format('jYYYY/jMM/jDD'),
            )
          : null,
        endDate: filters.find((a) => a.keyName === 'dateRange')?.value?.end
          ? enifyDateTime(
              filters.find((a) => a.keyName === 'dateRange').value?.end?.format('jYYYY/jMM/jDD'),
            )
          : null,
      };

      const data = {
        filterVOS: [],
        parentParams: [],
        orderByElementVOS: [],
      };
      setParamsData({ ...params });
      setFilterParams({ data, params });
      let res = [];
      reportElement['imprestList']
        ? (res = await ImprestServices.getImprestReport(params))
        : (res = await ImprestServices.getImprest(params));

      let list = [];

      list = generateData(res.result, {
        page: query ? query?.pageNumber : page,
        pageSize: query?.pageSize || size,
      });

      setTotoalCount(res?.count);

      setAccountDetails(list);

      setLoading(false);

      let d = {
        data: list,
        page: query ? query?.pageNumber : page,
        totalCount: res?.count,
      };
      return d; //passed to MaterialTable
    } catch (error) {
      setLoading(false);
      return {
        data: [],
        page: query ? query?.pageNumber : page,
        totalCount: 0,
      };
    }
  };

  // تابع برای تغییر وضعیت انتخاب همه ردیف‌ها
  const paginationOnChange = async (param) => {
    if (param?.changeData) {
      // صفحه جاری در این بخش ست میش
      setCurrentPage(param?.page == 0 ? 1 : param?.page);
    }
  };

  //-- OTHER FUNCTIONS --//
  const onFiltersChange = async (newFilters) => {
    setFilters(newFilters);
    filterTemp = newFilters;
    if (currentPage !== 1) {
      setCurrentPage(1);
    } else {
      getBranchesList();
    }
  };

  const hint =
    'در این بخش مالک کسب و کار میتواند لیست شعبه های تنخواه گردان را مشاهده و ویرایش کند.';

  return (
    <>
      <PageContainer
        title="لیست تنخواه گردان"
        description={hint}
        breadcrumbs={constBreadCrumbsTitle.IMPREST_LIST}
        className={classes.root}
      >
        <Grid item xs={12}>
          <Box
            display="flex"
            justifyContent="end"
            alignItems="flex-end"
            style={{ marginBottom: 16, gap: matches ? '5px' : '0' }}
            className={classes.btnActions}
          >
            {
              // اگر بهش این دسترسی داده شده باشه
              actionsList['imprestListTable'] && (
                <FilterButton setOpenFilterDialog={setOpenFilterDialog} filters={filters} />
              )
            }
              {reportElement['imprestList'] ? (
              // <ReceiveFile type={'imprestList'} paramsData={paramsData} isFormatExport={true} />
              <></>
            ) : (
              actionsList['imprestListRedirectToAddImprestBtn'] && (
                <Button
                  className={classes.cardHeaderButton}
                  onClick={() => navigate('/Imprest/Add')}
                  color="primary"
                  variant="contained"
                  startIcon={<Icons icon="plusCircle" color="#fff" size="18" />}
                >
                  ایجاد تنخواه گردان
                </Button>
              )
            )}
         
          </Box>
          {
            // اگر بهش این دسترسی داده شده باشه
            actionsList['imprestListTable'] && (
              <Box>
                <FilterPod
                  filters={filters}
                  onChange={onFiltersChange}
                  openFilterDialog={openFilterDialog}
                  setOpenFilterDialog={setOpenFilterDialog}
                  handleCloseFilterDialog={handleCloseFilterDialog}
                />
              </Box>
            )
          }
        </Grid>

        {actionsList['imprestListTable'] && (
          <>
            {loading ? <LoadingPage /> : null}
            {accountDetails?.length === 0 && !loading ? <Empty /> : null}
            {
              // درصورتیکه کلید برگردد ، یعنی کامپوننت جدید را نمایش بدهیم ، در غیراینصورت کامپوننت یا صفحه قدیمی رو برای کاربر نمایش میدهیم
              reportElement['imprestList'] ? (
                <Grid container spacing={2}>
                  {!loading && accountDetails?.length !== 0
                    ? accountDetails.map((item, k) => (
                        <Grid item xs={12} sm={6} md={6} lg={4}>
                          <ImprestItemReport
                            data={item}
                            dataGuild={accountDetails}
                            setAccountDetails={setAccountDetails}
                            accDetails={accountDetails}
                            key={k}
                            itemKey={k}
                            refreshList={getBranchesList}
                            actionsList={actionsList}
                            currencyText={currencyText}
                          />
                        </Grid>
                      ))
                    : null}
                </Grid>
              ) : (
                <Grid container spacing={2}>
                  {!loading && accountDetails?.length !== 0
                    ? accountDetails.map((item, k) => (
                        <Grid item xs={12} sm={6} md={6} lg={4}>
                          <ImprestItem
                            data={item}
                            dataGuild={accountDetails}
                            setAccountDetails={setAccountDetails}
                            accDetails={accountDetails}
                            key={k}
                            itemKey={k}
                            refreshList={getBranchesList}
                            actionsList={actionsList}
                          />
                        </Grid>
                      ))
                    : null}
                </Grid>
              )
            }

            {!loading && accountDetails?.length > 0 ? (
              <Grid justifyContent="center" container style={{ marginTop: 16 }}>
                <PaginationComponenets
                  itemsPerPage={12}
                  currentPage={currentPage}
                  pageCount={totalCount}
                  onChange={paginationOnChange}
                  removePrePage={true}
                />
              </Grid>
            ) : null}
          </>
        )}
      </PageContainer>
      <ImprestReportSummary />
    </>
  );
}